import "./svg";
// import * as common from "./common";
import lottie from "./components/lottie";
import pageTransitions from "./components/barba";
import nav from "./components/header";

window.addEventListener("load", () => {
  lottie.init();    
  nav.init();    
  // common.init();    
  pageTransitions.init();    
});